import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DetallePedidoDTO } from 'src/app/model/detallePedidoDTO';
import { PedidoClienteDTO } from 'src/app/model/pedidoClienteDTO';
import { PedidoService } from 'src/app/services/api/pedido.service';
import { PedidoDTOService } from 'src/app/services/api/pedidoDTO.service';
import { ProductoDTOService } from 'src/app/services/api/productoDTO.service';
import { TokenStorageServiceCliente } from 'src/app/services/api/TokenStorageServiceCliente';
import { environment } from 'src/environments/environment';
declare let $: any;
@Component({
  selector: 'app-pedido-cliente',
  templateUrl: './pedido-cliente.component.html',
  styleUrls: ['./pedido-cliente.component.css']
})
export class PedidoClienteComponent implements OnInit{
  @ViewChild('myModal')myModal!: ElementRef;
  CantidadItem:string="0";
  idUsrDTO?:number;
  pedidoCliente:PedidoClienteDTO[]=[];
  detallePedidoDTO:DetallePedidoDTO[]=[];
  tipoMedia$ : String = "/0";
  urlServerUpload$ : string = `${environment.HOST}/api/media/`;
  afiliacionNeoNetDTO:string="";
nombreEmpresaDTO:string="";
nombreTarjetaDTO:string="";
cuotaDTO:string="";
timeLocalTransDTO:string="";
dateLocalTransDTO:string="";
direccionEmpresaDTO:string="";
noTarjetaDTO?:string="0";
sysTraceNo?:string ="0";
fechaPedidoDTO?:Date;
horaPedidoDTO?:String;
retrievalResponseDTO?:string="0";
authResponseDTO?:string="";
granTotalDTO?:number=0;
idTipoTransaccionDTO?:number=0;
countpedido:string="0";
nombreCuenta:String="Mi cuenta";
tieneSession:boolean=false ;
modoBusqueda:boolean=false;
currentPage:number=0;
totalPages:number=0;
ocultarCarrito:boolean=false;
page = 0;
size = 6;
order = 'descripcion';
asc = true;
content:any = [];
formBuscar!: FormGroup;
  constructor(
    private router:Router,
    private tokenStorage: TokenStorageServiceCliente,
    private pedidoService :PedidoService,
    private detallePedidoDTOService : PedidoDTOService,
    private pedidoDTOService:PedidoDTOService,
    private productoDTOService : ProductoDTOService,

    
  ){


  }

  ngOnInit() {


    this.formBuscar = new FormGroup({
      'txtBuscar' : new FormControl('', Validators.required),
    });

    if (this.tokenStorage.getToken()==null) {
    
      this.router.navigateByUrl('/login-cliente/3');
    }else {

      this.CantidadItem=localStorage.getItem('countPedido')+"";
      if (this.tokenStorage.getToken()!==null) {
        let json = JSON.stringify(this.tokenStorage.getUser());
        let data=JSON.parse(json.toString());
        this.idUsrDTO=data.idUsuario;
        this.nombreCuenta=data.nombre;
        this.tieneSession=true ;
          }

          
          this.OnGetCredencialNeoNet();
          this.onGetPedidoByClienteUsuario(this.idUsrDTO);

    }  


  }
  onGetPedidoByClienteUsuario(idUsuario:any){
    this.detallePedidoDTO=[];

    this.pedidoService.getPedidoByIdClienteUsuario(idUsuario).subscribe(response =>{
      console.log(response)
      return this.pedidoCliente=response
    })
  
  }

  OnVerDetallePedido(idPedido:any,idEstado:number){

this.pedidoCliente=[];

    this.detallePedidoDTOService.getDetallePedidoById(idPedido,idEstado).subscribe(response =>{
      console.log(response)
      return this.detallePedidoDTO=response
    })


  }




  OnHabilitarBusqueda(){
    this.ocultarCarrito=true;
  }
  
  OnCerrarBusqueda(){
    this.ocultarCarrito=false;
  }






  OnVerPagoElectronico(idPedido:any,idEstado:any,formPago:any){

  if (formPago==1 || formPago==2){

 
 
    this.OnGetDatosPagoPedido(idPedido);
 
 
    $(this.myModal.nativeElement).modal('show') ;


  }else {
    alert("SU PEDIDO ES: CONTRA ENTREGA, NO EXISTE PAGO ELECTRÓNICO");
  }
    
    
      }




OnRegresar(){

  this.onGetPedidoByClienteUsuario(this.idUsrDTO);

}



OnGetCredencialNeoNet(){
  this.pedidoService.getCredencialNeoNet().subscribe(response =>{

 //this.credencialesNeoNet=response;
  

 for(let dato of response) {
  this.afiliacionNeoNetDTO=(dato.afiliacion+"");
  this.nombreEmpresaDTO=(dato.nombreEmpresa+"");
  this.direccionEmpresaDTO=(dato.direccion+"");

 }



  });



}

OnContinuar(){
  $(this.myModal.nativeElement).modal('hide'); 

}


OnFormatoTimeLocalTrans(_dato:any){

  let hora=_dato.substring(0,2);
  let min=_dato.substring(2,4);
  let nuevahora=hora+":"+min;
  
  return nuevahora;
  
  
  }




OnGetDatosPagoPedido(idPedido:any){
  this.pedidoService.getTransaccionElectronica(Number(idPedido)).subscribe(response =>{
//console.log(response);

    
 for(let dato of response) {
  this.authResponseDTO=(dato.authIdResponse+"");
  this.retrievalResponseDTO=(dato.retrievalRefNo+"");
  this.sysTraceNo=(dato.systemTraceno+"");
  this.noTarjetaDTO=(dato.tarjeta+"");
  this.fechaPedidoDTO=(dato.fecha);
  this.horaPedidoDTO=dato.hora+"";
  this.nombreTarjetaDTO="";
  this.idTipoTransaccionDTO=dato.idTipoTransaccion;
  this.granTotalDTO=dato.total;
  this.nombreTarjetaDTO=dato.nombreTarjeta+"";
  this.timeLocalTransDTO= this.OnFormatoTimeLocalTrans(dato.timeLocalTrans+"");
  this.dateLocalTransDTO= dato.fecha+"";
  this.cuotaDTO=dato.cuota+"";
 }



  });

}


logout(){
  this.tokenStorage.signOut();
  this.router.navigateByUrl('/inicio');
  localStorage.removeItem('cliente_stg');
  localStorage.removeItem('Respuesta_Neo_Net');
}



OnBuscarAll(){

  this.modoBusqueda=true;
  this.currentPage=0;
  this.content=[];

this.CargarPorDescripcionPg();

  }

  OnSelectProducto(idproducto:any){
    this.router.navigate(['/pedido', idproducto,0,0,0,0,0])
    .then(() => {
      window.location.reload();
    });

  
  }



  CargarPorDescripcionPg(){
        

    this.productoDTOService.getProductosDTOByDescripcionPg(this.currentPage, this.size, this.order, this.asc,0,this.formBuscar.value['txtBuscar']).subscribe(
      data => {
        this.content.push(...data.content);
      
      this.totalPages=data.totalPages;
        console.log(data);
      },
      err => {
        console.log(err.error);
      }
    );

  }


  onScroll(){
    if(this.modoBusqueda==false){
      //this.currentPage++;
     // this.cargarProductoPg();
    }else{
      this.currentPage++;
      this.CargarPorDescripcionPg();
    }

   
  }



}
